import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
  FormDashboardInput as Input,
  FormDashboardLabel as Label,
  SaveButton,
  FormRow,
} from "../../../components";
import { changeEmail, fetchAccount } from "../../../features/account/slice";
import { errorHandler, formUpdater } from "../../../utils";

const FormEmail = () => {
  const dispatch = useDispatch()
  const id = useSelector(state => state.account.profile.accountId)
  const [form, setForm] = React.useState({ id });
  const [requesting, setRequesting] = React.useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log({form});

    if (form.email) {
      const c = window.confirm('You will be logged out after your email successfully changed. Are you sure want to change your email now?')
      if(c){
        setRequesting(true);
        dispatch(changeEmail(form))
          .then((res) => {
            console.log(res);
            if(!res.payload){
              const msg = errorHandler(res.error)
              toast.error(msg)
            } else {
              toast.success("Email sucessfully changed!");
              dispatch(fetchAccount())
            }
          })
          .catch(err => {
            const msg = errorHandler(err)
            toast.error(msg)
          })
          .finally(() => {
            setRequesting(false);
          });
      }
    } else {
      toast.error("Invalid form.");
    }
  };

  const updateForm = (e) => formUpdater(e, form, setForm);

  return (
    <form onSubmit={handleSubmit}>
      <FormRow>
        <Label>New Email Address</Label>
        <Input
          required
          className="w-full"
          type="email"
          name="email"
          onChange={updateForm}
        />
      </FormRow>
      {/* note: di API kalau mau ganti email ga perlu password (?) */}
      {false && (
        <FormRow last>
          <Label>Your Current Password</Label>
          <Input
            className="w-full"
            type="password"
            name="password"
            onChange={updateForm}
          />
        </FormRow>
      )}
      <SaveButton disabled={requesting} isLoading={requesting} />
    </form>
  );
};

export { FormEmail };
